import { useCallback } from "react";
import {
  saveTextCareSourceForProcessing,
  resolveAsyncCareSourceTypeForText,
} from "../features/careSourceProcessing";
import { getCalendarDateKey } from "../utils/calendarDateKey";
export default function useBackgroundCareCapture({
  setCareToastMessage,
  setCareToastSeverity,
  setCareToastOpen,
}) {
  return useCallback(
    async ({
      child,
      text = "",
      captureDate = null,
      inputMode = "composer",
      sourceName = "Typed note",
    } = {}) => {
      const cleanText = String(text || "").trim();
      if (!child?.id || !cleanText) {
        return false;
      }

      try {
        const result = await saveTextCareSourceForProcessing({
          childId: child.id,
          rawText: cleanText,
          sourceType: resolveAsyncCareSourceTypeForText(cleanText),
          sourceName,
          inputMode,
          selectedDate: captureDate,
          selectedLocalDate:
            captureDate instanceof Date
              ? getCalendarDateKey(captureDate)
              : null,
        });
        if (!result?.ok || !result.sourceNoteId)
          throw new Error("Capture save was not acknowledged.");
        setCareToastMessage(
          "Saved source. We're organizing care details in the background.",
        );
        setCareToastSeverity("success");
        setCareToastOpen(true);
        window.dispatchEvent(
          new CustomEvent("captureez:timeline-refresh", {
            detail: {
              childId: child.id,
            },
          }),
        );
        return true;
      } catch (error) {
        console.error("Error saving source for background processing:", error);
        return false;
      }
    },
    [setCareToastMessage, setCareToastSeverity, setCareToastOpen],
  );
}
